export const FETCH_ITEM = 'MY_UTHEALTH_EDITOR/FETCH_ITEM';
export const FETCH_ITEM_SUCCESS = 'MY_UTHEALTH_EDITOR/FETCH_ITEM_SUCCESS';
export const FETCH_ITEM_ERROR = 'MY_UTHEALTH_EDITOR/FETCH_ITEM_ERROR';
export const FETCH_CLINICS = 'MY_UTHEALTH_EDITOR/FETCH_CLINICS';
export const FETCH_CLINICS_SUCCESS = 'MY_UTHEALTH_EDITOR/FETCH_CLINICS_SUCCESS';
export const FETCH_CLINICS_ERROR = 'MY_UTHEALTH_EDITOR/FETCH_CLINICS_ERROR';
export const FETCH_LOCATIONS = 'MY_UTHEALTH_EDITOR/FETCH_LOCATIONS';
export const FETCH_LOCATIONS_SUCCESS = 'MY_UTHEALTH_EDITOR/FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_ERROR = 'MY_UTHEALTH_EDITOR/FETCH_LOCATIONS_ERROR';
export const ADD_TO_CART = 'MY_UTHEALTH_EDITOR/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'MY_UTHEALTH_EDITOR/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'MY_UTHEALTH_EDITOR/ADD_TO_CART_ERROR';
export const ADD_FAVORITE = 'MY_UTHEALTH_EDITOR/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'MY_UTHEALTH_EDITOR/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'MY_UTHEALTH_EDITOR/ADD_FAVORITE_ERROR';
export const CHECK_FAVORITE = 'MY_UTHEALTH_EDITOR/CHECK_FAVORITE';
export const CHECK_FAVORITE_SUCCESS = 'MY_UTHEALTH_EDITOR/CHECK_FAVORITE_SUCCESS';
export const CHECK_FAVORITE_ERROR = 'MY_UTHEALTH_EDITOR/CHECK_FAVORITE_ERROR';
export const SET_TEMPLATE_CODE = 'MY_UTHEALTH_EDITOR/SET_TEMPLATE_CODE';
export const SET_QUANTITY = 'MY_UTHEALTH_EDITOR/SET_QUANTITY';
export const SET_LANGUAGE = 'MY_UTHEALTH_EDITOR/SET_LANGUAGE';
export const SET_PRODUCT = 'MY_UTHEALTH_EDITOR/SET_PRODUCT';
export const SET_CLINIC_ID = 'MY_UTHEALTH_EDITOR/SET_CLINIC_ID';
export const SET_LOCATION_ID = 'MY_UTHEALTH_EDITOR/SET_LOCATION_ID';
export const SET_OTHER_LOCATION = 'MY_UTHEALTH_EDITOR/SET_OTHER_LOCATION';
export const SET_CLINIC_NAME = 'MY_UTHEALTH_EDITOR/SET_CLINIC_NAME';
export const SET_YOUR_LOCATION = 'MY_UTHEALTH_EDITOR/SET_YOUR_LOCATION';
export const SET_NOTES = 'MY_UTHEALTH_EDITOR/SET_NOTES';
export const RESET_STATE = 'MY_UTHEALTH_EDITOR/RESET_STATE';
export const SET_ACTION = 'MY_UTHEALTH_EDITOR/SET_ACTION';